// Dizzplace - karuzela produktow. Mechanizm przeniesiony z projektu Cossy:
// wlasny element HTML, ktory w konstruktorze uruchamia Swipera na swoim
// fragmencie strony. Biblioteka i jej arkusz ladowane sa w sekcji, nie
// globalnie, wiec podstrony bez karuzeli nie placa za nia niczym.
//
// Dlaczego biblioteka, a nie przewijanie na czystym CSS: wersja na
// scroll-snap wygladala dobrze na pelnym rzedzie, ale przy pelnym wyjsciu
// toru do krawedzi okna gubila punkt zerowy i karty startowaly ze srodka.
// Swiper liczy pozycje sam i trzyma je przy kazdej szerokosci.

if (!customElements.get('related-carousel')) {
  class KaruzelaProduktow extends HTMLElement {
    connectedCallback() {
      if (this.dataset.gotowa === '1') return;

      // Biblioteki nie ma na stronie od poczatku - wchodzi na zadanie, gdy
      // karuzela zbliza sie do ekranu (`assets/swiper-lazy.js`). Na stronie
      // produktu oba tory stoja gleboko pod pierwszym ekranem, wiec czesc
      // odwiedzajacych nie placi za nia wcale.
      if (typeof window.Swiper !== 'function') {
        if (window.dizzSwiper) {
          window.dizzSwiper.przyZblizeniu(this).then(() => this.connectedCallback(), () => {});
        } else {
          window.addEventListener('load', () => this.connectedCallback(), { once: true });
        }
        return;
      }

      const tor = this.querySelector('.swiper-container');
      if (!tor) return;
      this.dataset.gotowa = '1';

      // Jedna karta to nie karuzela: kropki byly elementem interfejsu, ktory
      // nic nie robi, a chwytanie sugerowalo przewijanie tam, gdzie nie ma
      // czego przewijac.
      const slajdow = this.querySelectorAll('.swiper-slide').length;
      if (slajdow < 2) {
        this.classList.add('related__carousel--jedna');
        return;
      }

      // Szerokosc karty bierze sie z projektu (313 px na szerokim ekranie),
      // wiec liczba kart na widoku nie jest ustawiana z gory: przy 'auto'
      // Swiper czyta wymiar z CSS i sam decyduje, ile ich wejdzie. Efekt
      // uboczny jest zgodny z projektem - przy krawedzi okna widac wycinek
      // nastepnej karty jako zapowiedz przewijania.
      // Licznik "1 / 5" jest opcjonalny - ma go instrukcja montazu, nie maja
      // produkty powiazane. Tak samo staly odstep miedzy kartami: bez
      // `data-space` zostaje rytm produktow powiazanych (12 px, od 750 px 24).
      // Licznik moze stac NAD torem (tak jest w instrukcji montazu), wiec
      // szukamy go takze u rodzica - inaczej cicho nie dziala.
      const licznik = this.querySelector('[data-carousel-count]')
        || (this.parentElement && this.parentElement.querySelector('[data-carousel-count]'));
      const odstep = Number(this.dataset.space) || 0;
      const pokazLicznik = (swiper) => {
        if (!licznik) return;
        licznik.textContent = `${swiper.realIndex + 1} / ${slajdow}`;
      };

      this.swiper = new window.Swiper(tor, {
        speed: 420,
        grabCursor: true,
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        spaceBetween: odstep || 12,
        a11y: {
          prevSlideMessage: this.dataset.prev || 'Poprzednie produkty',
          nextSlideMessage: this.dataset.next || 'Następne produkty',
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
        breakpoints: odstep ? {} : {
          750: { spaceBetween: 24 },
        },
        on: {
          init: pokazLicznik,
          slideChange: pokazLicznik,
        },
      });

      // Karuzela w ZWINIETEJ harmonijce (instrukcja montazu na telefonie) liczy
      // sie przy zerowej szerokosci, wiec po pierwszym rozwinieciu tor stoi w
      // zlym miejscu, dopoki czegos nie ruszy. Przeliczamy go w chwili otwarcia.
      const harmonijka = this.closest('details');
      if (harmonijka) {
        harmonijka.addEventListener('toggle', () => {
          if (harmonijka.open && this.swiper) this.swiper.update();
        });
      }
    }

    disconnectedCallback() {
      if (this.swiper) this.swiper.destroy(true, true);
      this.dataset.gotowa = '';
    }
  }

  customElements.define('related-carousel', KaruzelaProduktow);
}
